import { AlertType } from '@akmf/ng-shared';
import { Component, ChangeDetectionStrategy, Input, EventEmitter, Output, ChangeDetectorRef } from '@angular/core';

const AlertTypeToIcon = {
  [AlertType.Info]: 'error_outline',
  [AlertType.Success]: 'check_circle_outline',
  [AlertType.Warning]: 'report_problem',
  [AlertType.Error]: 'cancel',
};

@Component({
  selector: 'app-alert',
  templateUrl: './alert.component.html',
  styleUrls: ['./alert.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AlertComponent {
  @Input() title = 'Lorem ipsum dol or sit am et';
  @Input() alertType: AlertType = AlertType.Info;
  @Input() showCloseBtn = false;
  @Input() visible = false;
  @Input() headingLvl = 6;
  @Input() titleClass = 'h6';

  @Output() visibleChange: EventEmitter<boolean> = new EventEmitter<boolean>();

  AlertTypeToIcon = AlertTypeToIcon;
  AlertType = AlertType;

  constructor() {}

  onClose(): void {
    this.visible = false;
    this.visibleChange.emit(this.visible);
  }
}
